import { Building2, Users, ShieldCheck, Library, Fingerprint, DatabaseBackup } from "lucide-react";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import OrgMaster from "@/components/OrgMaster";
import EnterpriseMembers from "@/components/EnterpriseMembers";
import SuperAdmins from "@/components/SuperAdmins";
import LibraryRequests from "@/components/LibraryRequests";
import IsolationCheck from "@/components/IsolationCheck";
import DataExport from "@/components/DataExport";

const TABS = [["orgs", "Organizations", Building2, OrgMaster], ["members", "Enterprise members", Users, EnterpriseMembers],
  ["library", "Library requests", Library, LibraryRequests], ["super", "Super Admins", ShieldCheck, SuperAdmins], ["isolation", "Isolation check", Fingerprint, IsolationCheck], ["export", "Data export", DatabaseBackup, DataExport]];

export default function EnterprisePage({ onChanged }) {
  return (
    <div className="h-full overflow-y-auto p-4 lg:p-8" data-testid="enterprise-page">
      <p className="text-[11px] uppercase tracking-[0.2em] text-slate-500 font-semibold">Super Admin</p>
      <h1 className="text-3xl font-bold tracking-tight">Enterprise</h1>
      <p className="text-sm text-slate-600 mt-1 max-w-2xl">Organizations, staff sign-ins and Super Admins across ACE eSIGN. Patient records stay inside each organization; you see them only where an organization administrator has added you.</p>
      <Tabs defaultValue="orgs" className="mt-6">
        <TabsList className="flex-wrap h-auto">{TABS.map(([k, l, I]) => <TabsTrigger key={k} value={k} data-testid={`enterprise-tab-${k}`}><I className="w-4 h-4 mr-1.5" />{l}</TabsTrigger>)}</TabsList>
        {TABS.map(([k, , , C]) => <TabsContent key={k} value={k} className="mt-4"><C onChanged={onChanged} /></TabsContent>)}
      </Tabs>
    </div>
  );
}
